import { useState, useEffect } from 'react';

function usePagination(items, itemsPerPage) {
	const [currentPage, setCurrentPage] = useState(1);
	const totalPages = Math.max(1, Math.ceil(items.length / itemsPerPage));
	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const currentItems = items.slice(startIndex, endIndex);

	function goToPage(page) {
		setCurrentPage(page);
	}

	function nextPage() {
		if (currentPage < totalPages) {
			setCurrentPage(currentPage + 1);
		}
	}

	function prevPage() {
		if (currentPage > 1) {
			setCurrentPage(currentPage - 1);
		}
	}


	return {
		currentPage,
		setCurrentPage,
		totalPages,
		currentItems,
		goToPage,
		nextPage,
		prevPage,
	};
}

export default usePagination;
